<template>
  <div>
    <div
      class="game atn"
      v-show="!reaction"
      :style="params.users > 1 ? 'border-color:' + colors[inkey] : ''"
    >
      <div
        class="game__name"
        v-if="role === 'teacher'"
        :class="users > 5 ? 'game__name--wrap' : ''"
      >
        Игрок {{ inkey }}
        <div class="game__settings" @click="setShowsettings"></div>
      </div>
      <atn
        :qnt="axis_num"
        :params="params"
        :inkey="inkey"
        v-if="params.direction === false"
      ></atn>
      <nta
        :qnt="axis_num"
        :params="params"
        :inkey="inkey"
        v-if="params.direction === true"
      ></nta>
    </div>

    <div class="modsettings" v-if="showsettings">
      <div class="modsettings__back" @click="setShowsettings"></div>
      <div class="modsettings__body">
        <h2>Настройки тренажера Игрока {{ inkey }}</h2>
        <div class="instructions">
          <settings
            :inparams="params"
            :ingame="true"
            @params_changed="params_changed"
          ></settings>
        </div>
      </div>
    </div>

    <div class="wh-block wh-block--reaction" v-if="reaction">
      <div class="reaction">
        <!--<video loop muted preload="auto" autoplay>-->
        <video
          disableRemotePlayback
          preload="auto"
          autoplay
          @ended="stopReaction"
        >
          <source
            type="video/mp4"
            :src="'/storage/app/media/reactions/' + reaction_file"
            id="mp4"
          />
        </video>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { mix } from "./../mixin";
import atn from "./atn";
import nta from "./nta";
import settings from "./components/Settings";

export default {
  name: "game",
  mixins: [mix],
  components: {
    atn,
    nta,
    settings,
  },
  data() {
    return {
      expand: false,
      reaction: false,
      showsettings: false,
      params: "",
      /** Реакции */
      react_minus: [
        "muzyka_kostochek_-.mp4",
        "chtoby_stat_supergeroem_-.mp4",
        "tolko_vpered._ne_oglyadyvaysya_nazad.mp4",
        "pomogite.mp4",
        "01_dzhenias._idi_syuda-.mp4",
        "02_ne_boysya._ne_sem-.mp4",
        "03_te._kto_ne_razgadal_golovolomku-.mp4",
        "04_dostavay_abakus_i_treneruysya-.mp4",
        "05_kristally_nuzhno_zasluzhit-.mp4",
        "01_-_ne_vremya_grustit.mp4",
        "02_-_ne_vremya_veshat_nos.mp4",
        "03_-_ne_spi._drug.mp4",
        "04_-_budte_ostrymi.mp4",
      ],
      react_plus: [
        "priznavaysya_.mp4",
        "aplodismenty_v_kruge.mp4",
        "aplodismenty.mp4",
        "vot_eto_skorost.mp4",
        "uau._ty_-_supergeroy.mp4",
        "ey._podozhdi_menya._ya_za_toboy_ne_uspevayu.mp4",
        "01_ya_ne_veryu_svoim_glazam!_eto_fantastika!_+.mp4",
        "02_ya_rada_+.mp4",
        "03_yohou!_+.mp4",
        "04_vot_eto_skorost!_+.mp4",
        "05_molodec_drug!_+.mp4",
        "06_vy_porazili_menya!_+.mp4",
        "05_-_vasha_snorovka_vozhd.mp4",
        "06_-_molodcy_(logiya).mp4",
        "07_-_my_molodcy!_a_teper_mozhno_i_pospat.mp4",
        "08_-_ura._srabotalo.mp4",
        "09_-_ura.mp4",
        "10_-_ura!_na_ostrove.mp4",
        "11_-_ya_veryu_v_vas.mp4",
      ],
    };
  },
  props: {
    inkey: "",
  },

  computed: {
    axis_num() {
      let to = this.params.to * 1;
      return to;
    },
    users() {
      return this.$store.state.train.flash_params.users;
    },
    user() {
      return this.$store.state.user;
    },
    colors() {
      return this.$store.state.colors;
    },
    role() {
      return this.user.role.code;
    },
  },
  methods: {
    commitVal(value, param, method = "train/changeFlashParams") {
      let val = {
        param_name: param,
        param_val: value,
      };
      this.$store.commit(method, val);
    },
    scroll() {
      //UIkit.scroll('.headline2').scrollTo('.game__body');
    },
    startReaction(sum, userAnswer) {
      if (
        this.params.users === 1 &&
        this.params.qnt === 1 &&
        this.params.show_reactions
      ) {
        let type = sum == userAnswer ? "react_plus" : "react_minus";
        this.reaction_file = this.checkReaction(type);
        this.reaction = true;
      }
    },
    stopReaction() {
      this.reaction = false;
      this.reaction_file = "";
      let app = this;
      setTimeout(function () {
        UIkit.scroll(".headline2").scrollTo(".game");
        $("#repeat-" + app.inkey).focus();
      }, 100);
    },

    params_changed(val) {
      this.params = val;
      //this.current_step = 'finish';
      this.finish = true;
      let app = this;
      /*setTimeout(function () {
          app.reStartGame();
        }, 1000)*/
    },
    setShowsettings() {
      this.showsettings = !this.showsettings;
      if (this.showsettings) {
        $(document.body).addClass("fixed");
      } else {
        $(document.body).removeClass("fixed");
      }
    },
  },
  mounted() {
    this.params = _.cloneDeep(this.$store.state.train.flash_params);
  },
  beforeDestroy() {
    if (this.users === 1) {
      //this.$parent.commitVal(false, 'start')
    }
  },
};
</script>